import { retailersSlice } from './reducer';

export const { clearRetailers, fetchRetailers, receiveRetailers, setFilter } = retailersSlice.actions;
